module.exports = __webpack_public_path__ + "img/vehicle-test-01.fe29967e.png";